import React, { Component } from 'react';
import { Tabs, Tab } from '@mui/material';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import SectionEvaluation from './SectionEvaluation';
import ContentBox from '../../layout/ContentBox';
import { DetailedSectionEvaluation } from '../../../redux/types';

type Props = {
  evaluation: DetailedSectionEvaluation[];
  onTabClicked: (index: number) => void;
  currentSection: number;
  excludedQuestions: string[][];
}
class DetailedEvaluation extends Component<Props> {
  renderSection = (sectionIndex: number, section: DetailedSectionEvaluation): React.ReactNode => {
    const { excludedQuestions } = this.props;
    return (
      <SectionEvaluation
        key={`evaluationSection-${sectionIndex}`}
        section={section}
        excludedQuestionSection={excludedQuestions[sectionIndex]}
      />
    );
  };

  renderTabs = (evaluations: DetailedSectionEvaluation[]): React.ReactNode => {
    const { currentSection, onTabClicked } = this.props;
    const selection = currentSection !== undefined
      ? currentSection : 0;
    return (
      <div>
        <Tabs value={selection} indicatorColor="secondary" variant="scrollable" scrollButtons="auto">
          {
            evaluations.map((section, index) => {
              const key = `${section.headline}-${index}`;
              if (_.isEmpty(section.questions)) {
                return '';
              }

              return (
                <Tab
                  key={key}
                  label={section.headline || `Section ${index + 1}`}
                  onClick={() => {
                    onTabClicked(index);
                  }}
                  value={index}
                />
              );
            })
          }
        </Tabs>
        {this.renderSection(selection, evaluations[selection])}
      </div>
    );
  };

  render(): JSX.Element {
    const { evaluation } = this.props;
    return (
      <ContentBox elevation={0} title={<FormattedMessage id="trialdetails.surveyTitle" />}>
        {evaluation.length > 1
          ? this.renderTabs(evaluation)
          : this.renderSection(0, evaluation[0])}
      </ContentBox>
    );
  }
}

export default DetailedEvaluation;
